// extracted by mini-css-extract-plugin
export default {"container":"filter-module___container___c6f57a93","removeButton":"filter-module___removeButton___b4951252"};